


























































import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
const MaskedInput = require('vue-text-mask').default;
import { required, min, max } from 'vee-validate/dist/rules';
import Api from '../services/Api';

extend('required', required);
extend('max', max);
extend('min', min);

@Component({
  components: {
    ValidationObserver, ValidationProvider,
    MaskedInput
  }
})
export default class Reset extends Vue {
  private apiService: Api;
  spinner: boolean = false;
  private nomor: string = '';
  ktpPattern: Array<any> = new Array(16).fill(/\d/);

  constructor() {
    super();
    this.apiService = new Api();
  }

  submit() {
    this.spinner = true;
    this.apiService.postResource('/reset', {
      nomor: this.nomor
    }, true).then(r => {
      this.spinner = false;
      this.$toast.success('Data session peserta berhasil direset!');
    }).catch(err => {
      this.spinner = false;
      this.$toast.error(err.status + ' - ' + err.statusText);
    });
  }
}
